import React from 'react';

import { ImageIcon } from '@vlabs/icons';
import { useTranslation } from 'react-i18next';

import { CheckTypeCard } from './CheckTypeCard';
import st from './shared.module.sass';

const ImageTypeCard = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <CheckTypeCard
      icon={<ImageIcon />}
      iconClassName={st.ImageIconBg}
      onClick={onClick}
      title={t('checks:check type card.image.title')}
      subtitle={t('checks:check type card.image.subtitle')}
    />
  );
};

export default ImageTypeCard;
